module.exports = __webpack_public_path__ + "static/scale-model-of-rattlesnake-museum-in-albuquerque-new-mexico-baa8bf66555b74e3fc96220a6f1ae181.png";